import React from 'react';
import {useTranslation} from 'react-i18next';

const HomeWhyUs = ({embedded = false}) => {
  const {t} = useTranslation();
  const benefits = t('main_page.why_us.benefits', {returnObjects: true});
  const intro = t('main_page.why_us.intro');
  const items = Array.isArray(benefits) ? benefits : [];
  const content = (
    <div className="row gutter-width-sm align-items-start why-us-layout">
      <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12">
        <div className="why-us-header">
          <div className="title">
            <h2>{t('main_page.why_us.title')}</h2>
          </div>
          {intro ? <p className="why-us-intro">{intro}</p> : null}
          <p className="why-us-lead">{t('main_page.why_us.lead')}</p>
        </div>
      </div>

      <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12">
        <ul className="why-us-list">
          {items.map((benefit, index) => (
            <li key={benefit} className="why-us-item">
              <span className="why-us-item-number">{`0${index + 1}`}</span>
              <p>{benefit}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );

  if (embedded) {
    return (
      <div id="why-us" className="why-us-section why-us-section-embedded">
        {content}
      </div>
    );
  }

  return (
    <section id="why-us" className="why-us-section block spacer p-top-xl p-bottom-xl">
      <div className="wrapper">
        {content}
      </div>
    </section>
  );
};

export default HomeWhyUs;
